import { Link, navigate } from "gatsby"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AppContext from "../context/AppContext"

const StyledHeader = styled.header`
  background: #fff;
  position: relative;
  padding: 31px;
`

const HeaderContainer = styled.div`
  max-width: ${props => props.theme.smallContainerWidth};
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 35px;
  }

  div:nth-child(2) {
    width: 390px;
  }

  div:nth-child(4) {
    width: 450px;
  }

  img {
    max-width: 100px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 60px;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    div ${StyledLink} {
      display: none;
    }
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.primaryFont};
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  padding: 2px 10px;

  > span {
    background-color: ${props => props.theme.primaryColor};
    color: white;
    border-radius: 50%;
    display: inline-block;
  }

  svg {
    /* vertical-align: top; */
  }

  &:hover,
  &.active {
    color: white;
    background: ${props => props.theme.primaryColor};
  }

  &:hover {
    svg,
    g,
    polyline,
    path {
      stroke: white !important;
      fill: white !important;
    }
  }
`

const HamburgerMenu = styled.span`
  display: none;

  span {
    width: 20.4px;
    height: 3px;
    display: block;
    background: ${props => props.theme.primaryColor};
    margin-bottom: 3px;
    transition: all ease-in-out 0.3s;
  }

  &.active {
    span:nth-child(1) {
      transform: rotate(45deg);
    }

    span:nth-child(2) {
      margin-top: -6px;
      transform: rotate(-45deg);
    }

    span:nth-child(3) {
      display: none;
    }
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    display: block;
    cursor: pointer;
  }
`

const MobileMenu = styled.div`
  background: #fff;
  position: absolute;
  top: 85px;
  left: 0;
  width: 100vw !important;
  height: 100vh;
  z-index: 100;
  padding: 10px 30px;
  display: block !important;

  ${StyledLink} {
    display: block !important;
    line-height: 45px;
  }
`

const MobileLink = styled(StyledLink)`
  display: none;
  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    display: block;
  }
`
const SubMenu = styled.div`
  position: absolute;
  background: #fff;
  box-shadow: 0 10px 19px 0 rgba(124, 125, 83, 0.34);
  top: -30px;
  left: 0;
  transform: translate(0, 100%);
  z-index: 1111;
  display: flex;
  flex-direction: column !important;
  padding: 10px 10px;
  box-sizing: border-box;
  cursor: pointer !important;

  span {
    display: block;
  }
`

const AccountLink = styled.span`
  text-decoration: none;
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.primaryFont};
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  position: relative;
  padding: 2px 10px;

  &:hover,
  &.active {
    color: white;
    background: ${props => props.theme.primaryColor};
  }
`

const AccountSubmenu = () => {
  return (
    <SubMenu>
      <StyledLink to="/account/">Account</StyledLink>
      <StyledLink to="/">Log Out</StyledLink>
    </SubMenu>
  )
}

const Header = ({ siteTitle }) => {
  const [mobileMenuActive, setMobileMenuActive] = useState(false)
  const [isLoggedIn, setLoggedIn] = useState(false)
  const [subMenuActive, setSubMenu] = useState(false)

  useEffect(() => {
    if (window.localStorage.user) {
      let user = JSON.parse(window.localStorage.user)
      if (user.access_token) {
        setLoggedIn(true)
      }
    }
  }, [])

  const logout = e => {
    localStorage.clear()
    setLoggedIn(false)
  }

  return (
    <AppContext.Consumer>
      {appContext => (
        <StyledHeader
          onMouseLeave={() => {
            setSubMenu(false)
          }}
        >
          <HeaderContainer>
            <HamburgerMenu
              className={mobileMenuActive ? "active" : null}
              onClick={() => setMobileMenuActive(!mobileMenuActive)}
            >
              <span />
              <span />
              <span />
              {mobileMenuActive ? (
                <MobileMenu>
                  <StyledLink activeClassName="active" to="/how-it-works/">
                    How It Works
                  </StyledLink>
                  <StyledLink activeClassName="active" to="/settings/">
                    Settings
                  </StyledLink>
                  <StyledLink activeClassName="active" to="/products/">
                    Products
                  </StyledLink>
                  <StyledLink activeClassName="active" to="/contact-us/">
                    Contact Us
                  </StyledLink>
                  <StyledLink activeClassName="active" to="/sign-up/">
                    Sign Up
                  </StyledLink>
                </MobileMenu>
              ) : null}
            </HamburgerMenu>
            <div>
              <StyledLink activeClassName="active" to="/how-it-works/">
                How It Works
              </StyledLink>
              <StyledLink activeClassName="active" to="/products/">
                Products
              </StyledLink>
            </div>
            <Link to="/">
              <img src="/images/prang_logo.png" alt="" />
            </Link>
            <div>
              <StyledLink to="/contact-us/">Contact Us</StyledLink>
              {!isLoggedIn ? (
                <>
                  <StyledLink activeClassName="active" to="/login/">
                    <FontAwesomeIcon icon="sign-in-alt" />
                    &nbsp; Login
                  </StyledLink>
                  <StyledLink activeClassName="active" to="/sign-up/">
                    Sign Up
                  </StyledLink>
                </>
              ) : (
                <>
                  <AccountLink
                    to="/account/"
                    activeClassName="active"
                    onMouseEnter={() => {
                      setSubMenu(true)
                    }}
                  >
                    Account &nbsp; <FontAwesomeIcon icon="chevron-down" />
                    {subMenuActive ? (
                      <SubMenu
                        onMouseLeave={() => {
                          setSubMenu(false)
                        }}
                      >
                        <StyledLink to="/settings/">Settings</StyledLink>
                        <StyledLink onClick={e => logout(e)} to="/">
                          Log Out
                        </StyledLink>
                      </SubMenu>
                    ) : null}
                  </AccountLink>
                  <StyledLink to="/cart/">
                    {" "}
                    <FontAwesomeIcon icon="shopping-cart" /> &nbsp; Cart{" "}
                    {/* Context Consumer for Cart Count */}
                    <span>
                      &nbsp;&nbsp;{appContext.state.cart.length}&nbsp;&nbsp;
                    </span>
                  </StyledLink>
                </>
              )}
            </div>
            {!isLoggedIn ? (
              <MobileLink to="/login/">
                <FontAwesomeIcon icon="sign-in-alt" />
                &nbsp; Login
              </MobileLink>
            ) : (
              <MobileLink onClick={e => logout(e)} to="/">
                <FontAwesomeIcon icon="sign-in-alt" />
                &nbsp; Logout
              </MobileLink>
            )}
          </HeaderContainer>
        </StyledHeader>
      )}
    </AppContext.Consumer>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
